export default __webpack_public_path__ + "static/media/test.9ead50cf.jpg";